import { Accordion, AccordionItem, AccordionPanel, AccordionTrigger } from '@wundo/ui';
import type { InsightChatStep } from '@wundo/shared/insightChat.ts';
import { stepLabel } from './stepLabel.ts';

export interface RunStepProps {
  step: InsightChatStep;
}

/**
 * One step the analyst took, folded to a line: what it did, and on opening,
 * exactly what it sent and what came back. Steps are read to check how an
 * answer was reached, not followed as speech, so they sit across the width.
 */
export function RunStep({ step }: RunStepProps) {
  return (
    <Accordion>
      <AccordionItem className='bg-fill-faint'>
        <AccordionTrigger className='px-3.5 py-2.5 text-sm font-normal text-ink-secondary'>
          <span className='truncate'>{stepLabel(step)}</span>
        </AccordionTrigger>
        <AccordionPanel>
          <div className='flex flex-col gap-2.5 px-3.5 pb-3.5'>
            <div className='rounded-md border border-line bg-surface px-3 py-2'>
              <p className='mb-1 text-xs font-bold text-ink-secondary'>Sent</p>
              <pre className='overflow-x-auto text-xs leading-5 break-all whitespace-pre-wrap text-ink-body'>
                {typeof step.args.sql === 'string'
                  ? step.args.sql
                  : JSON.stringify(step.args, null, 2)}
              </pre>
            </div>
            <div className='rounded-md bg-fill px-3 py-2'>
              <p className='mb-1 text-xs font-bold text-ink-secondary'>Came back</p>
              <pre className='overflow-x-auto text-xs leading-5 break-all whitespace-pre-wrap text-ink-body'>
                {step.result}
                {step.result_truncated ? '\n…' : ''}
              </pre>
            </div>
          </div>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
